import React from "react";
import logo from "../Images/Logo.png";
import pic1 from "../Images/clients photos/neal-e-johnson-1541065-unsplash.jpg";
import pic2 from "../Images/clients photos/zachary-tan-1551160-unsplash.jpg";
import pic3 from "../Images/clients photos/joseph-chan-1553994-unsplash.jpg";
import pic4 from "../Images/clients photos/riccardo-mion-1551100-unsplash.jpg";
import pic5 from "../Images/clients photos/md-duran-1551156-unsplash.jpg";
import pic6 from "../Images/clients photos/md-duran-1551170-unsplash.jpg";
import pic7 from "../Images/clients photos/thao-le-hoang-1553111-unsplash.jpg";
import pic8 from "../Images/clients photos/raychan-1560719-unsplash.jpg";
import pic9 from "../Images/clients photos/uriel-soberanes-1511839-unsplash.jpg";

export default function Footer() {
  return (
    <footer className="front-page-footer">
      <div className="container mt-4">
        <img src={logo} alt="logo" className="img-fluid logo" />
        <div className="row">
          <div className="col-12 col-md-4">
            <div>
              <h5 className="text-center">Contact info</h5>
              <div className="d-flex align-items-center my-3">
                <i className="fas fa-map-marker footer-icon mr-4" />
                <h5>Poole Edge 123 - Fairbanks, United States</h5>
              </div>
              <div className="d-flex align-items-center my-3">
                <i className="fas fa-envelope footer-icon mr-4" />
                <h5>1234@unitravel.com</h5>
              </div>
              <div className="d-flex align-items-center my-3">
                <i className="fas fa-phone footer-icon mr-4" />
                <h5>+1 123 456 789</h5>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <h5 className="text-center">Our social media profile</h5>
            <div className="d-flex align-items-center my-3">
              <i className="fab fa-facebook footer-icon mr-4" />
              <h5>Facebook</h5>
            </div>
            <div className="d-flex align-items-center my-3">
              <i className="fab fa-instagram footer-icon mr-4" />
              <h5>Instagram</h5>
            </div>
            <div className="d-flex align-items-center my-3">
              <i className="fab fa-twitter footer-icon mr-4" />
              <h5>Twitter</h5>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <h5 className="text-center">Photos from our clients</h5>
            <div className="row">
              <div className="col-4">
                <img src={pic1} alt="pic1" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic2} alt="pic2" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic3} alt="pic3" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic4} alt="pic4" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic5} alt="pic5" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic6} alt="pic6" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic7} alt="pic7" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic8} alt="pic8" className="img-fluid my-1 rounded" />
              </div>
              <div className="col-4">
                <img src={pic9} alt="pic9" className="img-fluid my-1 rounded" />
              </div>
            </div>
          </div>
        </div>
        <div className="pb-2">
          <h5 className="text-center">© Unitravel 2019</h5>
        </div>
      </div>
    </footer>
  );
}
